import {tshirtsCategoryRedesignTest} from '../../utils/constants/signalmanConstants';

const ELIGIBLE_PATHNAME = '/products/t-shirts/4';

document.addEventListener('DOMContentLoaded', () => {
  if (window.location.pathname === ELIGIBLE_PATHNAME) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'ab_test_group',
      interaction_action: 'tshirts category redesign view',
      ab_test_name: '2025 08 21 tshirts category redesign',
      ab_test_location: window.location.pathname,
      ab_test_group: tshirtsCategoryRedesignTest
    });
  }
});
